import NumberFormat from 'react-number-format';
import Input2 from './input-2/Input2';
import { Controller } from 'react-hook-form';

const InputWithFormat = ({
    format = null,
    mask = '',
    onChange,
    prefix = '',
    suffix = '',
    defaultValue = '',
    ...props
}) => (
    <Input2
        {...props}
        inputCreator={(inputProps, control) => {
            if (props.fieldName && control) {
                return (
                    <Controller
                        name={props.fieldName}
                        control={control}
                        rules={inputProps.rules}
                        render={({ field: { onChange, onBlur, name, value, ref } }) => (
                            <NumberFormat
                                {...inputProps}
                                className="ffe-input-field"
                                onValueChange={({ value }) => onChange && onChange(value ? `${prefix}${value}` : '')}
                                defaultValue={`${value}`.replace(prefix, '')}
                                format={format}
                                mask={mask}
                                prefix={prefix}
                                thousandSeparator={' '}
                                inputMode="numeric"
                                name={name}
                                onBlur={onBlur}
                                ref={ref}
                            />
                        )}
                    />
                );
            }
            return (
                <NumberFormat
                    {...inputProps}
                    className="ffe-input-field"
                    onValueChange={({ value, formattedValue }) =>
                        onChange && onChange({ value: `${value && prefix}${value}`, formattedValue })
                    }
                    defaultValue={`${defaultValue}`.replace(prefix, '')}
                    format={format}
                    mask={mask}
                    prefix={prefix}
                    suffix={suffix}
                    thousandSeparator={' '}
                    inputMode="numeric"
                />
            );
        }}
    />
);
export default InputWithFormat;
